(function() {
  'use strict';

  // This directive is being used for numbers in affiliate table for now
  // but it is implemented to be reusable
  angular.module('ringbaPortal').directive('scrollableTableCell', scrollableTableCell);

  function scrollableTableCell(
    $window
  ) {
    'ngInject';

    const directive = {
      restrict: 'E',
      replace: true,
      scope: {
        list: '<',
        viewAllText: '@',
        limitList: '<',
        popoverClass: '@'
      },
      require: 'scrollableTableCell',
      link: link,
      transclude: {
        'limitedItems': '?limitedItems',
        'allItems': '?allItems'
      },
      controller: function() {}, // Dummy controller to use 'vm.' in views
      controllerAs: 'vm',
      bindToController: true,
      templateUrl: '/scripts/shared/directives/scrollable-table-cell/scrollable-table-cell.view.html'
    };
    return directive;

    function link(scope, element, attributes, controller) {
      const $scrollTableCellCtrl = controller;

      $window.document.addEventListener('click', _onDocumentClick, true);
      $window.document.addEventListener('keydown', _bindEscTabKeyPress, true);
      scope.$on('$destroy', _onScopeDestroy);

      function _onDocumentClick(e) {
        if (!$scrollTableCellCtrl.showAll) {
          return;
        }

        if (!$.contains(element[0], e.target)) {
          _closePopover();
        }
      }

      function _bindEscTabKeyPress(evt) {
        if (!$scrollTableCellCtrl.showAll) {
          return;
        }

        let isEscape;
        if ('key' in evt) {
          isEscape = (evt.key === 'Escape' || evt.key === 'Esc');
        } else {
          isEscape = (evt.keyCode === 27 || evt.keyCode === 9);
        }
        if (isEscape) {
          _closePopover();
        }

      }

      function _closePopover() {
        $scrollTableCellCtrl.showAll = false;
        scope.$digest();
      }

      function _onScopeDestroy() {
        $window.document.removeEventListener('click', _onDocumentClick, true);
        $window.document.removeEventListener('keydown', _bindEscTabKeyPress, true);
      }
    }
  }

})();
